import * as Types from '../../../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetOrganisationTeamsQueryVariables = Types.Exact<{
  uuid: Types.Scalars['String']['input'];
}>;


export type GetOrganisationTeamsQuery = { __typename?: 'Query', organisation: { __typename?: 'Organisation', id: string, teams: Array<{ __typename?: 'OrganisationTeam', id: string, uuid: string, name: string }> } };


export const GetOrganisationTeamsDocument = gql`
    query GetOrganisationTeams($uuid: String!) {
  organisation(uuid: $uuid) {
    id
    teams {
      id
      uuid
      name
    }
  }
}
    `;

/**
 * __useGetOrganisationTeamsQuery__
 *
 * To run a query within a React component, call `useGetOrganisationTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationTeamsQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetOrganisationTeamsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganisationTeamsQuery, GetOrganisationTeamsQueryVariables> & ({ variables: GetOrganisationTeamsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganisationTeamsQuery, GetOrganisationTeamsQueryVariables>(GetOrganisationTeamsDocument, options);
      }
export function useGetOrganisationTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganisationTeamsQuery, GetOrganisationTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganisationTeamsQuery, GetOrganisationTeamsQueryVariables>(GetOrganisationTeamsDocument, options);
        }
// @ts-ignore
export function useGetOrganisationTeamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganisationTeamsQuery, GetOrganisationTeamsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganisationTeamsQuery, GetOrganisationTeamsQueryVariables>;
export function useGetOrganisationTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganisationTeamsQuery, GetOrganisationTeamsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganisationTeamsQuery | undefined, GetOrganisationTeamsQueryVariables>;
export function useGetOrganisationTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganisationTeamsQuery, GetOrganisationTeamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganisationTeamsQuery, GetOrganisationTeamsQueryVariables>(GetOrganisationTeamsDocument, options);
        }
export type GetOrganisationTeamsQueryHookResult = ReturnType<typeof useGetOrganisationTeamsQuery>;
export type GetOrganisationTeamsLazyQueryHookResult = ReturnType<typeof useGetOrganisationTeamsLazyQuery>;
export type GetOrganisationTeamsSuspenseQueryHookResult = ReturnType<typeof useGetOrganisationTeamsSuspenseQuery>;
export type GetOrganisationTeamsQueryResult = Apollo.QueryResult<GetOrganisationTeamsQuery, GetOrganisationTeamsQueryVariables>;